@if (profileService.profile$ | async; as profile) {
  <ng-template
    appComponentsHost (onLoad)="onLoad($event)"
    profileData="{{profile}}"
    componentName="{{componentName}}"
    moduleName="TileModal"
    pageID="{{pageID}}">
  </ng-template>
}
